import { ISort } from '../common/types';
import { AxiosResponse } from 'axios';
import { formatSortingFields } from '../common/helpers';
import { ApiSaleOrderService } from '../../services';
import { IFlightAndFlightAncillaryETicketSummaryList, IFlightAndFlightAncillaryIssueSummaryList } from './types';

export const getFlightAndAncillaryETicketsList = (
	page = 1,
	size = 10,
	sortingFields: ISort[],
	filters?: Record<string, string | number | boolean>,
	search?: string,
): Promise<AxiosResponse<IFlightAndFlightAncillaryETicketSummaryList>> => {
	const sorts = formatSortingFields(sortingFields);
	return ApiSaleOrderService.get('/flight-and-flight-ancillary-eticket-summaries', {
		params: {
			page,
			size,
			...(sorts.length > 0 && { sort: sorts }),
			...(filters && filters),
			...(search && { search: search }),
			envelope: true,
		},
	});
};

export const getFlightAndAncillaryETicketsListToExport = (
	sortingFields: ISort[],
	filters?: Record<string, string | number | boolean>,
): Promise<AxiosResponse<IFlightAndFlightAncillaryETicketSummaryList>> => {
	const sorts = formatSortingFields(sortingFields);
	return ApiSaleOrderService.get('/flight-and-flight-ancillary-eticket-summaries', {
		params: {
			page: 1,
			...(sorts.length > 0 && { sort: sorts }),
			...(filters && filters),
			envelope: true,
		},
	});
};

// Nuevos servicios para flight-and-flight-ancillary-issue-summaries
export const getFlightAndAncillaryIssueSummariesList = (
	page = 1,
	size = 10,
	sortingFields: ISort[],
	filters?: Record<string, string | number | boolean>,
	search?: string,
): Promise<AxiosResponse<IFlightAndFlightAncillaryIssueSummaryList>> => {
	const sorts = formatSortingFields(sortingFields);
	return ApiSaleOrderService.get('/flight-and-flight-ancillary-issue-summaries', {
		params: {
			page,
			size,
			...(sorts.length > 0 && { sort: sorts }),
			...(filters && filters),
			...(search && { search: search }),
			envelope: true,
		},
	});
};

export const getFlightAndAncillaryIssueSummariesListToExport = (
	sortingFields: ISort[],
	filters?: Record<string, string | number | boolean>,
): Promise<AxiosResponse<IFlightAndFlightAncillaryIssueSummaryList>> => {
	const sorts = formatSortingFields(sortingFields);
	return ApiSaleOrderService.get('/flight-and-flight-ancillary-issue-summaries', {
		params: {
			page: 1,
			...(sorts.length > 0 && { sort: sorts }),
			...(filters && filters),
			envelope: true,
		},
	});
};
